import {
  FileMultipleStroke,
  FilePlusCircleStroke,
  Pencil1Stroke,
  RefreshCircle1ClockwiseStroke,
  SignPostLeftStroke,
  Trash3Stroke
} from '@lineiconshq/free-icons';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';

/**
 * Props for the ActionBar component
 */
interface ActionBarProps {
  isViewDisabled?: boolean;
  onAddClick?: () => void;
  onEditClick?: () => void;
  onDeleteClick?: () => void;
  onCopyClick?: () => void;
  onViewClick?: () => void;
  onRefreshClick?: () => void;
  onFixedColumnsClick?: () => void;
  onExportClick?: () => void;
  onImportFromExcel?: () => void;
  isExporting?: boolean;
}

/**
 * ActionBar component for the Balance Sheet by Unit page
 */
const ActionBar: React.FC<ActionBarProps> = ({
  isViewDisabled = false,
  onAddClick,
  onEditClick,
  onDeleteClick,
  onCopyClick,
  onViewClick,
  onFixedColumnsClick,
  onRefreshClick,
  onExportClick,
  onImportFromExcel,
  isExporting = false
}) => {
  return (
    <ActionBarV2 titleComponent={<h1 className='text-xl font-bold'>Danh mục nhà cung cấp</h1>}>
      {onAddClick && <ActionButtonV2 icon={FilePlusCircleStroke} title='Thêm' onClick={onAddClick} />}
      {onEditClick && (
        <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEditClick} disabled={isViewDisabled} />
      )}
      {onDeleteClick && (
        <ActionButtonV2 icon={Trash3Stroke} title='Xóa' onClick={onDeleteClick} disabled={isViewDisabled} />
      )}
      {onCopyClick && (
        <ActionButtonV2 icon={FileMultipleStroke} title='Sao chép' onClick={onCopyClick} disabled={isViewDisabled} />
      )}
      {onViewClick && <ActionButtonV2 icon={RefreshCircle1ClockwiseStroke} title='Refresh' onClick={onRefreshClick} />}
      {onFixedColumnsClick && (
        <ActionButtonV2 icon={SignPostLeftStroke} title='Cố định cột' onClick={onFixedColumnsClick} />
      )}

      <MenuButtonV2
        title='Khác'
        items={[
          {
            title: 'Cập nhật trạng thái doanh nghiệp',
            icon: <AritoIcon icon={15} />,
            onClick: () => {},
            group: 0
          },
          {
            title: 'Kết xuất dữ liệu',
            icon: <AritoIcon icon={555} />,
            onClick: onExportClick,
            loading: isExporting,
            loadingTitle: 'Đang kết xuất dữ liệu...',
            group: 0
          },
          {
            title: 'Tải mẫu Excel',
            icon: <AritoIcon icon={28} />,
            onClick: () => {},
            group: 1
          },
          {
            title: 'Lấy dữ liệu từ Excel',
            icon: <AritoIcon icon={29} />,
            onClick: onImportFromExcel || (() => {}),
            group: 1
          },
          {
            title: 'Phân tích nhóm nhiều khách hàng',
            icon: <AritoIcon icon={774} />,
            onClick: () => {},
            group: 2
          },
          {
            title: 'Ẩn/hiển thị cây phân nhóm',
            icon: <AritoIcon icon={538} />,
            onClick: () => {},
            group: 2
          }
        ]}
      />
    </ActionBarV2>
  );
};

export default ActionBar;
